import { render, staticRenderFns } from "./OrderManagement.vue?vue&type=template&id=181975ef&scoped=true&"
import script from "./OrderManagement.vue?vue&type=script&lang=js&"
export * from "./OrderManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181975ef",
  null
  
)

export default component.exports